/**
 * Replaces angular2-materialize tabs.
 */
import {
  Directive,
  ElementRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

declare const M: any;

@Directive({
  selector: '[materializeTabs]'
})
export class TabsDirective implements AfterViewInit, OnDestroy {

  private tabsInitialized = false;
  private routerSub: Subscription | null = null;

  constructor(
    private el: ElementRef<HTMLElement>,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngAfterViewInit(): void {
    setTimeout(() => this.initTabs(), 0);

    this.routerSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.activateFragmentTab());
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
    this.tabsInitialized = false;
  }

  private initTabs(): void {
    const $ = (window as any).$;
    if (!$ || typeof $(this.el.nativeElement).tabs !== 'function') {
      console.warn('[TabsDirective] jQuery or Materialize tabs not available');
      return;
    }

    // Verify materialize tabs plugin is loaded
    if (typeof $(this.el.nativeElement).tabs !== 'function') {
      console.warn('[TabsDirective] Materialize tabs plugin not available');
      return;
    }

    $(this.el.nativeElement).tabs();
    this.tabsInitialized = true;
    this.activateFragmentTab();
  }

  private activateFragmentTab(): void {
    if (!this.tabsInitialized) return;

    const $ = (window as any).$;
    if (!$) return;

    const frag = this.route.snapshot.fragment;
    if (!frag) return;

    const tabId = frag.replace('#', '');
    const tabContent = document.getElementById(tabId);
    if (!tabContent) return;

    setTimeout(() => {
      try {
        $(this.el.nativeElement).tabs('select_tab', tabId);
      } catch (e) {
        console.warn('[TabsDirective] could not activate tab:', tabId, e);
      }
    });
  }
}
